import { useState } from "react";
import NavOption from "./NavOption";
import React, { useEffect } from "react";
import EpimsLogoOnly from "./EpimsLogoOnly";
import FriendlyGreeting from "./FriendlyGreeting";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'

function LeftNav({userRealName, activeTab, doLogout, loginCount, sectionsVisited, markSectionVisited}) {

    const [isCollapsed, setIsCollapsed] = useState(false)
    const [isReady, setIsReady] = useState(false)

    const initialiseMenu = () => {
        if (window.matchMedia("(width <= 800px)").matches) {
            setIsCollapsed(true)
            document.getElementById('navMenu')?.scrollTo(0, 0)
        } else {
            setIsCollapsed(false)
        }
        setIsReady(true)
    }

    useEffect(() => {
        initialiseMenu()
        window.addEventListener("resize", initialiseMenu)
        return () => window.removeEventListener("resize", initialiseMenu)
    }, []);

    if (!isReady) return null;

    var reportListExtraProps = {}
    if (loginCount === 1 && !sectionsVisited.includes('main')) {
      reportListExtraProps = {
        notifications: 1
      }
    }
    
    return (
        <div id="navMenu" className={"navMenu" + (isCollapsed ? ' collapsed' : '')}>
          <div>
            {!isCollapsed && <FontAwesomeIcon onClick={() => {setIsCollapsed(!isCollapsed)}} icon={solid("close")} className="navMenuControlButton" />}
            {isCollapsed && <FontAwesomeIcon onClick={() => {setIsCollapsed(!isCollapsed)}} icon={solid("bars")} className="navMenuControlButton" />}
            <div className="navLogoWrapper">
                <EpimsLogoOnly xxxsmall={true} />
            </div>
          </div>
          <FriendlyGreeting userRealName={userRealName} />
          <div className="navSection">
            <div className="navSectionName">Welcome</div>
            <NavOption callback={initialiseMenu} activeTab={activeTab} url='/home' name='home' displayName='Getting Started' {...{markSectionVisited, sectionsVisited}} />
          </div>
          <div className="navSection">
            <div className="navSectionName">Reports</div>
            <NavOption callback={initialiseMenu} activeTab={activeTab} url='/uploadXml' name='new' displayName='Create Report' {...{markSectionVisited, sectionsVisited}} />
            <NavOption callback={initialiseMenu} activeTab={activeTab} url='/reports' name='main' displayName='Report List' {...reportListExtraProps} {...{markSectionVisited, sectionsVisited}} />
            <NavOption callback={initialiseMenu} activeTab={activeTab} url='/deleted' name='deleted' displayName='Deleted Reports' {...{markSectionVisited, sectionsVisited}} />
          </div>
          <div className="navSection">
            <div className="navSectionName">Settings</div>
            <NavOption callback={initialiseMenu} activeTab={activeTab} url='/settings' name='settings' displayName='Branding' {...{markSectionVisited, sectionsVisited}} />
            <NavOption callback={initialiseMenu} activeTab={activeTab} url='/account' name='myaccount' displayName='My Account' {...{markSectionVisited, sectionsVisited}} />
          </div>
          <div style={{textAlign: "center", marginRight: "15px", marginTop: "24px", width: "199px"}}><button id="logOutButton" className="btn btn-primary" onClick={doLogout}>Log out</button></div>
          <div className="termsLinks">
              <p><a style={{textDecoration: "none"}} href={"https://" + process.env.REACT_APP_WWW_BASE_DOMAIN + "/terms/privacy_policies.html"} target="_blank" rel="noreferrer">Privacy Policy</a></p>
              <p><a href={"https://" + process.env.REACT_APP_WWW_BASE_DOMAIN + "/terms/EPA%20Terms.pdf"} target="_blank" rel="noreferrer">Terms and Conditions</a></p>
          </div>
        </div>
    );
}

export default LeftNav;